import React, { Component } from 'react';

import { AnalysisQuestion } from './AnalysisQuestion';
import { AnalysisQuestionMap } from './AnalysisQuestionMap';

// COMPONENT
export class AnalysisEditor extends Component {
    constructor(props) {
        super(props);
        this.analysisQuestionComponent = React.createRef();
    }

    onNodeClick = questionId => {
        this.analysisQuestionComponent.current.onInfoClick(questionId);
    };

    render() {
        return (
            <div id="questionnaireRow" className="row mt-3">
                <div className="col-sm-7">
                    <AnalysisQuestion ref={this.analysisQuestionComponent} />
                </div>
                <div className="col-sm-5">
                    <AnalysisQuestionMap onNodeClick={this.onNodeClick} />
                </div>
            </div>
        );
    }
}
